export { default } from './MessageList';
export { default as template } from './message-list.tpl';
